import { HistoryItem } from '../store/reducers/currentSequencedFlowPositionReducer';
import { Item, MenuItem, NonSequencedFlowItem, Quiz, SequencedFlowItem } from '@ael/core-api';
import { List } from 'immutable';

export enum menuAction {
  SideMenu_NavigateBack = 'SideMenu_NavigateBack',
  SideMenu_SelectedSubmenuItem = 'SideMenu_SelectedSubmenuItem',
  SideMenu_DeselectItem = 'SideMenu_DeselectItem',
  SideMenu_SelectNonSequencedFlowItem = 'SideMenu_SelectNonSequencedFlowItem',
  SideMenu_SelectSequencedFlowItem = 'SideMenu_SelectSequencedFlowItem',
  SideMenu_SelectedQuiz = 'SideMenu_SelectedQuiz',
  SideMenu_ExpandSubmenu = 'SideMenu_ExpandSubmenu',
  SideMenu_HideSideMenuButton = 'SideMenu_HideSideMenuButton',
  SideMenu_UnhideSideMenuButton = 'SideMenu_UnhideSideMenuButton',
  TopMenu_ToggleLeftSideMenu = 'TopMenu_ToggleLeftSideMenu',
  SideMenu_SelectedResource = 'SideMenu_SelectedResource',
  SideMenu_DeselectedResource = 'SideMenu_DeselectedResource',

  // Editor
  SideMenu_AddNewItem = 'SideMenu_AddNewItem',
  GuidedTourAction_Restart = 'GuidedTourAction_Restart',

  // content items in menu
  SideMenu_SelectHotspot = 'SideMenu_SelectHotspot',
}

export const SelectedSubmenuItemAction = (selectedItem: MenuItem, parentItemId: string | null) => ({
  type: menuAction.SideMenu_SelectedSubmenuItem,
  payload: {
    selectedItem,
    parentItemId,
  },
});

export const DeselectedMenuItemAction = (selectedItem: Item) => ({
  type: menuAction.SideMenu_DeselectItem,
  payload: {
    selectedItem,
  },
});

export const ExpandSubmenus = (parentSubmenuIds: List<string>) => {
  return {
    type: menuAction.SideMenu_ExpandSubmenu,
    payload: parentSubmenuIds,
  };
};

export const ToggleLeftSideMenuAction = {
  type: menuAction.TopMenu_ToggleLeftSideMenu,
};

export const SelectedNonSequencedFlowItemAction = (selectedItem: NonSequencedFlowItem) => ({
  payload: selectedItem,
  type: menuAction.SideMenu_SelectNonSequencedFlowItem,
});

export const SelectedSequencedFlowContentItemAction = (
  selectedItem: SequencedFlowItem,
  sequencedFlowStructure?: List<HistoryItem>
) => ({
  payload: { selectedItem, sequencedFlowStructure },
  type: menuAction.SideMenu_SelectSequencedFlowItem,
});

export const SelectedQuiz = (selectedItem: Quiz) => ({
  payload: selectedItem,
  type: menuAction.SideMenu_SelectedQuiz,
});

export const AddNewItemAction = {
  type: menuAction.SideMenu_AddNewItem,
};

export const SelectedHotspot = (hotspotId: string, isMobile: boolean) => ({
  type: menuAction.SideMenu_SelectHotspot,
  payload: { hotspotId, isMobile },
});

export const HideSideMenu = {
  type: menuAction.SideMenu_HideSideMenuButton,
};

export const UnhideSideMenu = {
  type: menuAction.SideMenu_UnhideSideMenuButton,
};

export const SelectedResource = (resourceId: string) => ({
  payload: resourceId,
  type: menuAction.SideMenu_SelectedResource,
});

export const DeselectedResource = (isMobile: boolean) => ({
  type: menuAction.SideMenu_DeselectedResource,
  payload: { isMobile },
});
